import React, { useContext, useRef, useState } from "react";

import { useAppSetting } from "@swa-ui/application";
import { LoadingDepiction } from "@swa-ui/core";
import { LocaleContext } from "@swa-ui/dotcom";
import { classNames } from "@swa-ui/string";

import { HotelContainer } from "../HotelContainer";
import styles from "./HotelBookingForm.module.scss";

export const HotelBookingForm = () => {
  const hotelIFrameData = useAppSetting("hotelIFrames") || {};
  const { locale } = useContext(LocaleContext);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  return (
    <div className={styles.container} ref={containerRef}>
      {loading && (
        <div className={styles.loading}>
          <LoadingDepiction template={getTemplateHotel()} />
        </div>
      )}
      <div
        className={getHotelContainerClassName()}
        style={{
          visibility: loading ? "hidden" : "visible",
        }}
      >
        <HotelContainer {...getHotelContainerProps()} />
      </div>
    </div>
  );

  function getHotelContainerClassName() {
    return classNames(styles.hotelContainer, {
      [styles.hotelContainerLoading]: loading,
    });
  }

  function getHotelContainerProps() {
    return {
      dataAttributes: {
        landing: {
          id: "landing-home-page-hotel-form",
        },
      },
      hotelIFrameData,
      iFrameIdentifier: "landing",
      language: locale,
      onCrossSellReady: () => setLoading(false),
    };
  }

  function getTemplateHotel() {
    return [
      {
        bottomMargin: "medium",
        numberOfColumns: 1,
      },
      {
        bottomMargin: "medium",
        color: "hotel-booking-form-template-color",
        numberOfRows: 5,
      },
    ];
  }
};
